import classNames from "classnames";

import { ChevronForwardIcon } from "@jti/brand-icons/chevron-forward";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";
import { useDirection } from "@jti/fe-common";

import styles from "./BreadcrumbItem.module.scss";

export type BreadcrumbItem = {
  title: string;
  url: string;
  hasPrev: boolean;
  tag?: keyof JSX.IntrinsicElements;
  isHidden: boolean;
};

export const BreadcrumbItem = ({ title, url, hasPrev, tag = "span", isHidden }: BreadcrumbItem) => {
  const direction = useDirection();
  const Component = tag;
  return (
    <li className={classNames(styles.breadcrumbItem, { [styles.hidden]: isHidden })}>
      {hasPrev ? <ChevronForwardIcon direction={direction} className={styles.breadcrumbChevron} /> : null}
      <LinkBehaviour className={styles.breadcrumbLink} href={url}>
        <Component className={styles.breadcrumbLinkText}>{title}</Component>
      </LinkBehaviour>
    </li>
  );
};
